export abstract class NavigationStore {}
